var widget_default = {
  "card": "atemu",
  "link": "Uw-TG",
  "container": "W3Lsv",
  "image": "ITIMx",
  "right": "D1U04",
  "cardLayout": "Oi3xL",
  "content": "kE6oT",
  "title": "JdPHz",
  "subtitle": "-EPs5",
  "button": "_3yaXs",
  "button_disabled": "bHYD1",
  "buttonText": "A-3Po",
  "slimLayout": "_7ylc1",
  "rtl": "y5cNn",
  "ltr": "eIIFb"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
